// Native & external imports
import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule  } from '@angular/router';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgOrderByPipeModule } from '@icamppro-customer-portal/shared/cmp-base';
import { CmpSharedModule } from 'icamppro-shared-components';
// Modules
import { AppLayoutModule } from 'src/app/app-layout.module';
import { PasswordResetModule } from 'src/modules/password-reset/password-reset.module';
// Pipes
import { LocalePipesModule } from 'src/pipes/localepipes.module';
import { LocaleDatePipe } from 'src/pipes/localedate.pipe';
// Components
import { LoginComponent } from 'src/components/login/login.component';
import { CamperRegistrationComponent } from 'src/components/camper-registration/camper-registration.component';
import { PrivacyPolicyComponent } from 'src/components/privacy-policy/privacy-policy.component';
import { TermsAndConditionComponent } from 'src/components/terms-and-condition/terms-and-condition.component';
import { FauxSelectMetaDropdownModule } from 'src/modules/faux-select-meta-dropdown/faux-select-meta-dropdown.module';
import { FauxDropdownWithInlineUiModule } from 'src/modules/faux-dropdown-with-inline-ui/faux-dropdown-with-inline-ui.module';
import { LottieComponent } from "ngx-lottie";
import { SharedUiComponentsModule } from 'src/modules/shared-ui-components/shared-ui-components.module';
import { LogoutComponent } from './logout/logout.component';
import { CmpSharedComponentsModule } from '@icamppro-customer-portal/shared/cmp-base';

// Exports
export { LoginComponent } from 'src/components/login/login.component';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CmpSharedModule,
    AppLayoutModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PasswordResetModule,
    LocalePipesModule,
    NgOrderByPipeModule,
    FauxSelectMetaDropdownModule,
    FauxDropdownWithInlineUiModule,
    LottieComponent,
    SharedUiComponentsModule,
    CmpSharedComponentsModule,
  ],
  declarations: [
    LoginComponent,
    LogoutComponent,
    CamperRegistrationComponent,
    TermsAndConditionComponent,
    PrivacyPolicyComponent,
  ],
  providers: [
    DatePipe,
    TitleCasePipe,
    LocaleDatePipe
  ],
  exports: [
  ]
})
export class WebsiteComponentsModule { }
